import { UAInfo, EventActions, ScrollActions, ClickActions } from './basis.js';

$(document).on('DOMContentLoaded', () => {
  let ua_info = new UAInfo();
  ua_info.setTabletViewport('1200');
  ua_info.setDeviceClass();
  ua_info.setOsClass();

  EventActions.setMediaQueryAction('screen and (max-width: 768px)');
  ScrollActions.setScrollButtonFade('.pagetop');
  ClickActions.setSmoothScroll(500, 0);

  ClickActions.setToggleDtDd('.faq-list');

  document.addEventListener('scroll', () => {
    let startOffset = document.documentElement.clientHeight / 2;
    if (ua_info.UA.device.type === 'tablet') {
      startOffset = document.documentElement.clientHeight / 3;
    }

    if (window.pageYOffset > startOffset / 2) {
      document.querySelector('.page_header').classList.add('fixed');
    } else {
      document.querySelector('.page_header').classList.remove('fixed');
    }
  });
});

$(window).on('load', () => {
  $('.loading').delay(1000).fadeOut(500);
  $('.container').delay(1500).addClass('visible');
});
